<template>
  <div>
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title>
          비밀번호
          <span class="asterisk">*</span>
        </v-list-item-title>
        <v-text-field solo required ref="refPassword" placeholder="비밀번호를 입력해주세요"
          :append-icon="pwShow2 ? 'mdi-eye' : 'mdi-eye-off'" :type="pwShow2 ? 'text' : 'password'"
          @click:append="pwShow2 = !pwShow2" :height="formHeight" :disabled="userData.signupPath === 'kakao'" :rules="[
            passwordRules.required,
            passwordRules.counter,
            passwordRules.check,
          ]" v-model="userData.password" />
        <span class="input-guide">
          영문 대소문자, 특수문자, 숫자를 포함한 6~20자리로 설정해 주세요
        </span>
      </v-list-item-content>
    </v-list-item>
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title>
          비밀번호 재입력
          <span class="asterisk">*</span>
        </v-list-item-title>
        <v-text-field solo required placeholder="비밀번호를 재 입력해주세요" :append-icon="pwShow3 ? 'mdi-eye' : 'mdi-eye-off'"
          :type="pwShow3 ? 'text' : 'password'" @click:append="pwShow3 = !pwShow3" :height="formHeight"
          :disabled="userData.signupPath === 'kakao'" :rules="[
            passwordRules.required,
            passwordRules.counter,
            passwordConfirmationRule,
          ]" v-model="userData.rePassword" />
        <span class="input-guide">
          재확인을 위해서 입력하신 비밀번호를 다시 입력해 주세요
        </span>
      </v-list-item-content>
    </v-list-item>
  </div>
</template>
<script>
// import { mapGetters } from "vuex";
const rulesService = require("@/utils/rules.js");
// const formatService = require("@/utils/format.js");

export default {
  props: {
    userData: {
      type: Object,
    },
  },
  data() {
    return {
      formHeight: 52,
      passwordRules: rulesService.passwordRules(),
      pwShow2: false,
      pwShow3: false,
    };
  },
  computed: {
    passwordConfirmationRule() {
      return () =>
        this.userData.password === this.userData.rePassword ||
        "패스워드가 일치해야 합니다.";
    },
    // ...mapGetters(["isAuthorized"]),
  },
};
</script>
<style lang="">
</style>